// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__4gN_y","modal":"Modal_modal__99I0C","close":"Modal_close__AXBq5","header":"Modal_header__IjlU6","closeInHeader":"Modal_closeInHeader__n9XSN"};